import { useEffect, useState } from 'react';
import { Modal, Button } from '@mantine/core';

interface ModalComponentProps {
  isOpen: boolean;
  title: React.ReactNode;
  size?: string;
  closeModal: () => void;
  styles?: Record<string, any>;
  children?: React.ReactNode;
  hasCloseButton?: boolean;
  closeOnClickOutside?: boolean;
}

const ModalComponent = ({ isOpen, title, size, closeModal, styles, children, hasCloseButton = true, closeOnClickOutside = true } : ModalComponentProps) => {
  const [opened, setOpened] = useState(isOpen);

  useEffect(() => {
      setOpened(isOpen);
  }, [isOpen]);

  const handleClose = () => {
      setOpened(false);
      closeModal();
  }
  
  return (
    <>
      <Modal size={size || 'md'} opened={opened} onClose={() => handleClose() } title={title} styles={{...styles}} withCloseButton={false} closeOnClickOutside={closeOnClickOutside} >
        {hasCloseButton && <img
          src="/images/ic-close.svg"
          alt="Close"
          style={{
            position: 'absolute',
            top: '35px',
            right: '30px',
            width: '13.57px',
            height: '13.57px',
            cursor: 'pointer',
            zIndex: 1000
          }}
          onClick={() => handleClose()}
        />}
          {children}
      </Modal>
    </>
  );
};

export default ModalComponent;
